export default __webpack_public_path__ + "img/bBiWxTbJ.3f0a2965.svg";